(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["goat-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    const initHoofTrail = () => {
      const layer = document.querySelector('[data-goat-motion-layer]');
      const hoofs = layer ? Array.from(layer.querySelectorAll('[data-goat-hoof]')) : [];

      if (!layer || hoofs.length === 0 || motionQuery.matches || layer.dataset.goatTrailReady === 'true') {
        return;
      }

      layer.dataset.goatTrailReady = 'true';
      let ticking = false;
      let lastScrollY = -1;
      const requestMotionFrame = typeof window.requestAnimationFrame === 'function'
        ? window.requestAnimationFrame.bind(window)
        : (callback) => window.setTimeout(callback, 16);
      const hoofAngles = [170, 190, 170, 190, 170, 190, 170, 190, 170, 220, 250, 280, 315, 0, 45, 80, 115, 150, 190, 190, 170, 190, 170];
      const contrastSections = Array.from(document.querySelectorAll('.goat-product-support__band--sample'));

      const syncHoofContrast = () => {
        if (contrastSections.length === 0) {
          return;
        }

        hoofs.forEach((hoof) => {
          const rect = hoof.getBoundingClientRect();
          const x = rect.left + rect.width / 2;
          const y = rect.top + rect.height / 2;
          const isInViewport = x >= 0 && x <= window.innerWidth && y >= 0 && y <= window.innerHeight;
          const isOverContrastSection = isInViewport && contrastSections.some((section) => {
            const sectionRect = section.getBoundingClientRect();

            return x >= sectionRect.left && x <= sectionRect.right && y >= sectionRect.top && y <= sectionRect.bottom;
          });

          hoof.classList.toggle('goat-motion-hoof--contrast', isOverContrastSection);
        });
      };

      const update = () => {
        const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        const progress = clamp(window.scrollY / maxScroll, 0, 1);
        lastScrollY = window.scrollY;

        hoofs.forEach((hoof, index) => {
          const start = index / Math.max(1, hoofs.length - 1) * 0.56;
          const local = clamp((progress - start) * 8.2, 0, 1);
          const rotation = hoofAngles[index] ?? 170;
          hoof.style.opacity = String(local * 0.56);
          hoof.style.transform = `translate(-50%, ${(1 - local) * 6}px) rotate(${rotation}deg)`;
        });

        syncHoofContrast();
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        requestMotionFrame(update);
      };

      const watchScrollPosition = () => {
        if (window.scrollY !== lastScrollY) {
          requestUpdate();
        }

        requestMotionFrame(watchScrollPosition);
      };

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      document.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);

      requestMotionFrame(watchScrollPosition);
    };

    const initSectionLines = () => {
      if (motionQuery.matches || !('IntersectionObserver' in window)) {
        return;
      }

      const selectors = [
        '.goat-wholesale-home',
        '.goat-home-details',
        '.goat-home-sample',
        '.goat-home-trust',
        '.goat-brand-page__story',
        '.goat-brand-page__mark',
        '.goat-brand-page__supply',
        '.goat-brand-page__cta',
        '.goat-learn-page__body-wrap',
        '.goat-learn-page__cta',
        '.goat-about-page__band',
        '.goat-about-page__section',
        '.goat-about-page__cta',
        '.goat-contact-page'
      ];

      const sections = Array.from(document.querySelectorAll(selectors.join(','))).filter((section) => section.dataset.goatMotionObserved !== 'true');

      if (sections.length === 0) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('goat-motion-section--seen');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });

      sections.forEach((section) => {
        section.dataset.goatMotionObserved = 'true';
        section.classList.add('goat-motion-section');
        observer.observe(section);
      });
    };

    const initLogoMoments = () => {
      if (motionQuery.matches || !('IntersectionObserver' in window)) {
        return;
      }

      const moments = Array.from(document.querySelectorAll('[data-goat-logo-moment]')).filter((moment) => moment.dataset.goatLogoObserved !== 'true');

      if (moments.length === 0) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('goat-logo-moment--seen');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.45 });

      moments.forEach((moment) => {
        moment.dataset.goatLogoObserved = 'true';
        observer.observe(moment);
      });
    };

    const initSmoothDetails = () => {
      if (motionQuery.matches) {
        return;
      }

      const detailsItems = Array.from(document.querySelectorAll('[data-goat-smooth-details]')).filter((details) => details.dataset.goatSmoothReady !== 'true');

      if (detailsItems.length === 0) {
        return;
      }

      detailsItems.forEach((details) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('[data-goat-details-panel]');
        const list = details.closest('.goat-home-details__list');

        if (!summary || !panel) {
          return;
        }

        details.dataset.goatSmoothReady = 'true';

        if (list) {
          list.classList.add('is-smooth-ready');
        }

        panel.style.height = details.open ? 'auto' : '0px';

        const finish = (isOpen) => {
          details.dataset.goatAnimating = 'false';
          details.classList.remove('is-opening', 'is-closing');

          if (isOpen) {
            panel.style.height = 'auto';
          } else {
            details.open = false;
            panel.style.height = '0px';
          }
        };

        const watchHeightTransition = (isOpen) => {
          const onEnd = (event) => {
            if (event.target !== panel || event.propertyName !== 'height') {
              return;
            }

            panel.removeEventListener('transitionend', onEnd);
            finish(isOpen);
          };

          panel.addEventListener('transitionend', onEnd);
          window.setTimeout(() => {
            if (details.dataset.goatAnimating === 'true') {
              panel.removeEventListener('transitionend', onEnd);
              finish(isOpen);
            }
          }, 520);
        };

        const openDetails = () => {
          details.dataset.goatAnimating = 'true';
          details.open = true;
          details.classList.add('is-opening');
          panel.style.height = '0px';
          void panel.offsetHeight;
          panel.style.height = `${panel.scrollHeight}px`;
          watchHeightTransition(true);
        };

        const closeDetails = () => {
          details.dataset.goatAnimating = 'true';
          details.classList.add('is-closing');
          panel.style.height = `${panel.scrollHeight}px`;
          void panel.offsetHeight;
          panel.style.height = '0px';
          watchHeightTransition(false);
        };

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (details.dataset.goatAnimating === 'true') {
            return;
          }

          if (details.open) {
            closeDetails();
          } else {
            openDetails();
          }
        });
      });
    };

    const initGoatMotion = () => {
      initHoofTrail();
      initSectionLines();
      initLogoMoments();
      initSmoothDetails();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGoatMotion);
    } else {
      initGoatMotion();
    }

    document.addEventListener('shopify:section:load', initGoatMotion);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goat-wholesale-purchase"] && !Shopify.designMode) return;
  try {
    const syncGoatWholesalePurchase = (root = document) => {
    const formatMoney = (amountInCents, currency) => {
      const locale = document.documentElement.lang || navigator.language || 'en-CA';
      const value = amountInCents / 100;
      const hasCents = amountInCents % 100 !== 0;

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency || 'CAD',
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: hasCents ? 2 : 0,
          maximumFractionDigits: hasCents ? 2 : 0
        }).format(value);
      } catch (error) {
        return `$${value.toFixed(hasCents ? 2 : 0)}`;
      }
    };

    const syncPurchaseMotion = (form, quantity) => {
      const motion = form.querySelector('[data-goat-purchase-motion]');

      if (!motion) {
        return;
      }

      const safeQuantity = Math.max(1, quantity || 1);
      const bottles = safeQuantity * 50;
      const caseCount = motion.querySelector('[data-goat-case-count]');
      const bottleCount = motion.querySelector('[data-goat-bottle-count]');
      const caseMeter = motion.querySelector('[data-goat-case-meter]');
      const caseTicks = motion.querySelectorAll('.goat-wholesale-home__case-tick');
      const caseWord = safeQuantity === 1 ? motion.dataset.goatCaseWordOne : motion.dataset.goatCaseWordOther;
      const bottleWord = motion.dataset.goatBottleWord || 'bottles';
      const motionState = `${safeQuantity}-${form.querySelector('[data-goat-selling-plan-select]')?.value || ''}`;

      if (caseCount) {
        caseCount.textContent = `${safeQuantity} ${caseWord || 'cases'}`;
      }

      if (bottleCount) {
        bottleCount.textContent = `${bottles} ${bottleWord}`;
      }

      caseTicks.forEach((tick, index) => {
        tick.classList.toggle('is-active', index < Math.min(safeQuantity, caseTicks.length));
      });

      if (caseMeter && caseMeter.dataset.goatMotionState !== motionState) {
        caseMeter.dataset.goatMotionState = motionState;
        caseMeter.classList.remove('is-updating');
        void caseMeter.offsetWidth;
        caseMeter.classList.add('is-updating');
      }

      const timeline = motion.querySelector('[data-goat-cadence-timeline]');
      const select = form.querySelector('[data-goat-selling-plan-select]');

      if (!timeline || !select) {
        return;
      }

      const selectedLabel = select.selectedOptions[0]?.textContent.trim() || '';
      const normalizedLabel = selectedLabel.toLowerCase();
      let cadenceMonths = 1;
      const mid = '50%';
      const end = '100%';

      if (normalizedLabel.includes('2')) {
        cadenceMonths = 2;
      } else if (normalizedLabel.includes('quarter') || normalizedLabel.includes('3')) {
        cadenceMonths = 3;
      } else if (normalizedLabel.includes('season') || normalizedLabel.includes('6')) {
        cadenceMonths = 6;
      }

      timeline.style.setProperty('--goat-cadence-mid', mid);
      timeline.style.setProperty('--goat-cadence-end', end);

      const formatOrderDate = (date) => {
        const locale = document.documentElement.lang || navigator.language || 'en-CA';

        try {
          return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
        } catch (error) {
          return `${date.getMonth() + 1}/${date.getDate()}`;
        }
      };

      const addCadenceMonths = (date, months) => {
        const result = new Date(date.getFullYear(), date.getMonth() + months, 1);
        const lastDay = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
        result.setDate(Math.min(date.getDate(), lastDay));
        return result;
      };

      const today = new Date();
      const labels = [
        motion.dataset.goatTodayLabel || 'Today',
        motion.dataset.goatNextLabel || 'Next',
        motion.dataset.goatFollowingLabel || 'Following'
      ];
      const orderDates = [
        today,
        addCadenceMonths(today, cadenceMonths),
        addCadenceMonths(today, cadenceMonths * 2)
      ];

      motion.querySelectorAll('[data-goat-cadence-date]').forEach((dateNode, index) => {
        const labelNode = dateNode.querySelector('[data-goat-cadence-date-label]');
        const valueNode = dateNode.querySelector('[data-goat-cadence-date-value]');

        if (labelNode) {
          labelNode.textContent = labels[index] || '';
        }

        if (valueNode && orderDates[index]) {
          valueNode.textContent = formatOrderDate(orderDates[index]);
        }
      });
    };

    const syncVariantMedia = (form, selectedVariant) => {
      if (!form || !selectedVariant) {
        return;
      }

      const purchase = form.closest('.goat-wholesale-home__purchase');
      const sectionRoot = form.closest('.shopify-section') || form.closest('[id^="MainProduct-"]') || document;
      const variantSize = selectedVariant.dataset.goatVariantSize;
      const productMedia = purchase ? purchase.closest('section')?.querySelector('[data-goat-product-media]') : null;

      if (productMedia && variantSize) {
        const frames = Array.from(productMedia.querySelectorAll('[data-goat-product-image]'));
        const targetFrame = frames.find((frame) => frame.dataset.goatProductImage === variantSize);

        if (targetFrame) {
          frames.forEach((frame) => {
            const isActive = frame === targetFrame;
            frame.classList.toggle('is-active', isActive);
            frame.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });
        }
      }

      const mediaId = selectedVariant.dataset.goatMediaId;

      if (!mediaId) {
        return;
      }

      const galleries = Array.from(sectionRoot.querySelectorAll('media-gallery'));
      const gallery = galleries.find((item) => Array.from(item.querySelectorAll('[data-media-id]')).some((media) => media.dataset.mediaId === mediaId));

      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, true);
      }
    };

    const syncTotal = (form) => {
      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const quantityInput = form.querySelector('[data-goat-quantity-input]');
      const total = form.querySelector('[data-goat-total-price]');

      if (!selectedVariant || !quantityInput || !total) {
        return;
      }

      const casePrice = Number.parseInt(selectedVariant.dataset.goatUnitPrice || '0', 10);
      const quantity = Math.max(1, Number.parseInt(quantityInput.value || '1', 10) || 1);
      const amount = casePrice * quantity;
      const displayCurrency = form.dataset.goatCurrency || 'CAD';

      total.textContent = formatMoney(amount, displayCurrency);
      syncPurchaseMotion(form, quantity);
      syncVariantMedia(form, selectedVariant);
    };

    const requestSyncFrame = typeof window.requestAnimationFrame === 'function'
      ? window.requestAnimationFrame.bind(window)
      : (callback) => window.setTimeout(callback, 16);

    const scheduleStableSync = (callback) => {
      callback();
      requestSyncFrame(callback);
    };

    const syncRelatedPurchaseForms = (form) => {
      const purchase = form.closest('.goat-wholesale-home__purchase');

      if (!purchase || form.dataset.goatSyncing === 'true') {
        return;
      }

      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const quantityInput = form.querySelector('[data-goat-quantity-input]');
      const selectedSellingPlan = form.querySelector('[data-goat-selling-plan-select]');

      purchase.querySelectorAll('.goat-wholesale-home__form').forEach((relatedForm) => {
        if (relatedForm === form) {
          return;
        }

        relatedForm.dataset.goatSyncing = 'true';

        if (selectedVariant) {
          const matchingVariant = Array.from(relatedForm.querySelectorAll('input[name="id"]')).find((input) => input.value === selectedVariant.value);

          if (matchingVariant) {
            matchingVariant.checked = true;
          }
        }

        if (quantityInput) {
          const relatedQuantity = relatedForm.querySelector('[data-goat-quantity-input]');

          if (relatedQuantity) {
            relatedQuantity.value = quantityInput.value;
          }
        }

        syncTotal(relatedForm);
        relatedForm.dataset.goatSyncing = 'false';
      });

      if (selectedSellingPlan) {
        purchase.querySelectorAll('[data-goat-muted-selling-plan-select]').forEach((select) => {
          select.value = selectedSellingPlan.value;
        });
      }
    };

    const getPurchaseState = (purchase) => {
      const activePanel = purchase.querySelector('[data-goat-purchase-panel]:not([hidden])') || purchase.querySelector('[data-goat-purchase-panel].is-active');
      const activeForm = activePanel ? activePanel.querySelector('.goat-wholesale-home__form') : purchase.querySelector('.goat-wholesale-home__form');

      return {
        mode: activePanel?.dataset.goatPurchasePanel || purchase.querySelector('[data-goat-purchase-toggle]:checked')?.value || 'subscription',
        variantId: activeForm?.querySelector('input[name="id"]:checked')?.value || '',
        quantity: activeForm?.querySelector('[data-goat-quantity-input]')?.value || '1',
        sellingPlan: activeForm?.querySelector('[data-goat-selling-plan-select]')?.value || ''
      };
    };

    const restorePurchaseState = (purchase, state) => {
      const matchingToggle = Array.from(purchase.querySelectorAll('[data-goat-purchase-toggle]')).find((input) => input.value === state.mode);

      if (matchingToggle) {
        matchingToggle.checked = true;
      }

      purchase.querySelectorAll('[data-goat-purchase-panel]').forEach((panel) => {
        const isActive = panel.dataset.goatPurchasePanel === state.mode;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      purchase.querySelectorAll('.goat-wholesale-home__form').forEach((form) => {
        const matchingVariant = Array.from(form.querySelectorAll('input[name="id"]')).find((input) => input.value === state.variantId);
        const quantityInput = form.querySelector('[data-goat-quantity-input]');
        const sellingPlanSelect = form.querySelector('[data-goat-selling-plan-select]');

        if (matchingVariant) {
          matchingVariant.checked = true;
        }

        if (quantityInput) {
          quantityInput.value = state.quantity || '1';
        }

        if (sellingPlanSelect && state.sellingPlan) {
          sellingPlanSelect.value = state.sellingPlan;
        }
      });
    };

    const syncCountryLocalizationControls = (nextDocument, countryCode) => {
      if (!nextDocument || !countryCode) {
        return;
      }

      document.querySelectorAll('form.localization-form').forEach((form) => {
        const countryInput = form.querySelector('input[name="country_code"]');
        const countrySelect = form.querySelector('select[name="country_code"]');

        if (!countryInput && !countrySelect) {
          return;
        }

        const nextForm = form.id ? nextDocument.getElementById(form.id) : null;
        const currentButtonLabel = form.querySelector('.disclosure__button span');
        const nextButtonLabel = nextForm ? nextForm.querySelector('.disclosure__button span') : null;

        if (countryInput) {
          countryInput.value = countryCode;
        }

        if (countrySelect) {
          countrySelect.value = countryCode;
        }

        if (currentButtonLabel && nextButtonLabel) {
          currentButtonLabel.textContent = nextButtonLabel.textContent;
        }

        form.querySelectorAll('.disclosure__link[data-value]').forEach((link) => {
          const isActive = link.dataset.value === countryCode;
          link.classList.toggle('disclosure__link--active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      });
    };

    root.querySelectorAll('.goat-wholesale-home__currency-button[data-goat-country-code]').forEach((button) => {
      if (button.dataset.goatCurrencyReady === 'true') {
        return;
      }

      button.dataset.goatCurrencyReady = 'true';
      button.addEventListener('click', async () => {
        const purchase = button.closest('.goat-wholesale-home__purchase');
        const localizationFormId = purchase?.dataset.goatLocalizationForm;
        const localizationForm = localizationFormId ? document.getElementById(localizationFormId) : null;

        if (!purchase || !localizationForm || button.getAttribute('aria-pressed') === 'true') {
          return;
        }

        const state = getPurchaseState(purchase);
        const currencyButtons = purchase.querySelectorAll('.goat-wholesale-home__currency-button[data-goat-country-code]');
        let replaced = false;

        purchase.setAttribute('aria-busy', 'true');
        currencyButtons.forEach((currencyButton) => {
          currencyButton.disabled = true;
        });

        try {
          const formData = new FormData(localizationForm);
          formData.set('country_code', button.dataset.goatCountryCode);

          await fetch(localizationForm.action || '/localization', {
            method: localizationForm.method || 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html'
            }
          });

          const response = await fetch(window.location.href, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'text/html'
            }
          });
          const html = await response.text();
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextPurchase = purchase.id ? nextDocument.getElementById(purchase.id) : null;

          syncCountryLocalizationControls(nextDocument, button.dataset.goatCountryCode);

          if (nextPurchase) {
            purchase.innerHTML = nextPurchase.innerHTML;
            restorePurchaseState(purchase, state);
            syncGoatWholesalePurchase(purchase);
            purchase.removeAttribute('aria-busy');
            replaced = true;
          }
        } catch (error) {
          purchase.removeAttribute('aria-busy');
        }

        if (!replaced) {
          purchase.removeAttribute('aria-busy');
          currencyButtons.forEach((currencyButton) => {
            currencyButton.disabled = false;
          });
        }
      });
    });

    root.querySelectorAll('[data-goat-purchase-switch]').forEach((switcher) => {
      if (switcher.dataset.goatSwitchReady === 'true') {
        return;
      }

      const purchase = switcher.closest('.goat-wholesale-home__purchase');
      const toggles = switcher.querySelectorAll('[data-goat-purchase-toggle]');
      const panels = purchase ? purchase.querySelectorAll('[data-goat-purchase-panel]') : [];

      if (!purchase || toggles.length === 0 || panels.length === 0) {
        return;
      }

      switcher.dataset.goatSwitchReady = 'true';

      const syncPanels = () => {
        const selected = switcher.querySelector('[data-goat-purchase-toggle]:checked')?.value || 'subscription';

        panels.forEach((panel) => {
          const isActive = panel.dataset.goatPurchasePanel === selected;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            const form = panel.querySelector('.goat-wholesale-home__form');

            if (form) {
              requestSyncFrame(() => {
                syncTotal(form);
                form.dispatchEvent(new Event('goat:purchase-panel-active', { bubbles: true }));
              });
            }
          }
        });
      };

      toggles.forEach((toggle) => {
        toggle.addEventListener('change', syncPanels);
      });

      syncPanels();
    });

    root.querySelectorAll('.goat-wholesale-home__form').forEach((form) => {
      if (form.dataset.goatTotalReady === 'true') {
        syncTotal(form);
        return;
      }

      form.dataset.goatTotalReady = 'true';
      form.addEventListener('input', () => {
        syncTotal(form);
        syncRelatedPurchaseForms(form);
      });
      form.addEventListener('change', () => {
        syncTotal(form);
        syncRelatedPurchaseForms(form);
      });
      scheduleStableSync(() => syncTotal(form));
    });

    root.querySelectorAll('[data-goat-quantity-control]').forEach((control) => {
      if (control.dataset.goatQuantityReady === 'true') {
        return;
      }

      const input = control.querySelector('[data-goat-quantity-input]');
      const decrease = control.querySelector('[data-goat-quantity-step="down"]');
      const increase = control.querySelector('[data-goat-quantity-step="up"]');

      if (!input || !decrease || !increase) {
        return;
      }

      control.dataset.goatQuantityReady = 'true';

      const getBounds = () => {
        const min = Number.parseInt(input.getAttribute('min') || '1', 10) || 1;
        const maxValue = Number.parseInt(input.getAttribute('max') || '', 10);

        return {
          min,
          max: Number.isNaN(maxValue) ? null : maxValue
        };
      };

      const getValue = () => {
        const bounds = getBounds();
        const parsed = Number.parseInt(input.value || String(bounds.min), 10);
        const current = Number.isNaN(parsed) ? bounds.min : parsed;
        const limitedMin = Math.max(bounds.min, current);

        return bounds.max === null ? limitedMin : Math.min(limitedMin, bounds.max);
      };

      const syncButtons = () => {
        const bounds = getBounds();
        const value = getValue();

        input.value = String(value);
        decrease.disabled = value <= bounds.min;
        increase.disabled = bounds.max !== null && value >= bounds.max;
      };

      const stepQuantity = (direction) => {
        const bounds = getBounds();
        const next = getValue() + direction;
        const limitedMin = Math.max(bounds.min, next);
        const value = bounds.max === null ? limitedMin : Math.min(limitedMin, bounds.max);

        input.value = String(value);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncButtons();
      };

      decrease.addEventListener('click', () => stepQuantity(-1));
      increase.addEventListener('click', () => stepQuantity(1));
      input.addEventListener('input', syncButtons);
      input.addEventListener('change', syncButtons);
      syncButtons();
    });

    root.querySelectorAll('.goat-wholesale-home__form--subscription').forEach((form) => {
      if (form.dataset.goatSubscriptionReady === 'true') {
        return;
      }

      form.dataset.goatSubscriptionReady = 'true';
      const select = form.querySelector('[data-goat-selling-plan-select]');

      const syncSubscription = () => {
        if (!select) {
          return;
        }

        let sellingPlanFields = form.querySelectorAll('input[name="selling_plan"]');

        if (sellingPlanFields.length === 0) {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'selling_plan';
          form.appendChild(field);
          sellingPlanFields = form.querySelectorAll('input[name="selling_plan"]');
        }

        sellingPlanFields.forEach((field) => {
          field.disabled = false;
          field.value = select.value;
        });
      };

      select?.addEventListener('change', syncSubscription);
      form.addEventListener('submit', syncSubscription, { capture: true });
      form.addEventListener('goat:purchase-panel-active', syncSubscription);
      scheduleStableSync(() => {
        syncSubscription();
        syncTotal(form);
      });
    });

    root.querySelectorAll('.goat-wholesale-home__form--onetime').forEach((form) => {
      if (form.dataset.goatOnetimeReady === 'true') {
        return;
      }

      form.dataset.goatOnetimeReady = 'true';

      const syncOnetime = () => {
        form.querySelectorAll('input[name="selling_plan"]').forEach((field) => {
          field.value = '';
          field.disabled = true;
        });
      };

      form.addEventListener('submit', syncOnetime, { capture: true });
      form.addEventListener('goat:purchase-panel-active', syncOnetime);
      scheduleStableSync(() => {
        syncOnetime();
        syncTotal(form);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncGoatWholesalePurchase());
  } else {
    syncGoatWholesalePurchase();
  }

  document.addEventListener('shopify:section:load', (event) => syncGoatWholesalePurchase(event.target));
  } catch(e) { console.error(e); }
})();

})();
